import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { CheckCircle2, RefreshCw, XCircle } from "lucide-react";
import { ImportResult } from "@/lib/api";

interface ImportResultModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  result: ImportResult | null;
}

export function ImportResultModal({ open, onOpenChange, result }: ImportResultModalProps) {
  const hasServiceColumn = result?.errors?.some((err) => err.service !== undefined) ?? false;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Resultado de la importación</DialogTitle>
        </DialogHeader>

        {result && (
          <div className="space-y-4">
            <div className="grid grid-cols-3 gap-3">
              <div className="flex flex-col items-center gap-1 rounded-lg border border-emerald-500/30 bg-emerald-500/10 py-3">
                <CheckCircle2 className="w-4 h-4 text-emerald-500" />
                <span className="text-xl font-bold text-foreground tabular-nums">{result.created}</span>
                <span className="text-xs text-muted-foreground">Creados</span>
              </div>
              <div className="flex flex-col items-center gap-1 rounded-lg border border-sky-500/30 bg-sky-500/10 py-3">
                <RefreshCw className="w-4 h-4 text-sky-500" />
                <span className="text-xl font-bold text-foreground tabular-nums">{result.updated}</span>
                <span className="text-xs text-muted-foreground">Actualizados</span>
              </div>
              <div className="flex flex-col items-center gap-1 rounded-lg border border-destructive/30 bg-destructive/10 py-3">
                <XCircle className="w-4 h-4 text-destructive" />
                <span className="text-xl font-bold text-foreground tabular-nums">{result.failed}</span>
                <span className="text-xs text-muted-foreground">Fallidos</span>
              </div>
            </div>

            {result.errors?.length > 0 && (
              <div className="max-h-72 overflow-y-auto rounded-lg border border-border">
                <Table>
                  <TableHeader>
                    <TableRow>
                      <TableHead className="h-9">Fila</TableHead>
                      <TableHead className="h-9">Email</TableHead>
                      {hasServiceColumn && <TableHead className="h-9">Servicio</TableHead>}
                      <TableHead className="h-9">Motivo</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {result.errors.map((err, idx) => (
                      <TableRow key={`${err.rowNumber}-${idx}`}>
                        <TableCell className="py-2 font-mono text-xs">{err.rowNumber}</TableCell>
                        <TableCell className="py-2 text-xs">{err.email}</TableCell>
                        {hasServiceColumn && (
                          <TableCell className="py-2 text-xs">{err.service}</TableCell>
                        )}
                        <TableCell className="py-2 text-xs text-destructive">{err.reason}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            )}
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
